import { tensureDarkTheme } from "./tensureDarkTheme";
import { tensureLightTheme } from "./tensureLightTheme";

export const tensureThemes = {
  dark: tensureDarkTheme,
  light: tensureLightTheme
} as const;